// assets/our-gallery-lightbox.js

(function () {
  function buildLightbox() {
    const lb = document.createElement('div');
    lb.id = 'gallery-lightbox';
    lb.innerHTML = `
      <div class="glb-backdrop"></div>
      <div class="glb-box">
        <button class="glb-close" aria-label="Close">&times;</button>
        <button class="glb-prev" aria-label="Previous">&#8249;</button>
        <button class="glb-next" aria-label="Next">&#8250;</button>
        <img class="glb-img" src="" alt="" />
        <div class="glb-caption"></div>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      #gallery-lightbox {
        display: none;
        position: fixed;
        inset: 0;
        z-index: 9999;
        align-items: center;
        justify-content: center;
      }
      #gallery-lightbox.active { display: flex; }
      .glb-backdrop {
        position: absolute;
        inset: 0;
        background: rgba(0,0,0,0.85);
        cursor: zoom-out;
      }
      .glb-box {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 92vw;
        max-height: 92vh;
      }
      .glb-img {
        max-width: 88vw;
        max-height: 80vh;
        object-fit: contain;
        border-radius: 8px;
        display: block;
        transition: opacity 0.2s ease;
      }
      .glb-img.loading { opacity: 0; }
      .glb-caption {
        margin-top: 12px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        min-height: 20px;
      }
      .glb-close {
        position: fixed;
        top: 16px;
        right: 20px;
        background: none;
        border: none;
        color: #fff;
        font-size: 36px;
        cursor: pointer;
        line-height: 1;
        padding: 4px 8px;
        z-index: 2;
      }
      .glb-prev, .glb-next {
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(255,255,255,0.12);
        border: 1px solid rgba(255,255,255,0.25);
        color: #fff;
        font-size: 32px;
        cursor: pointer;
        padding: 8px 14px;
        border-radius: 6px;
        line-height: 1;
        transition: background 0.15s;
        z-index: 2;
      }
      .glb-prev { left: 16px; }
      .glb-next { right: 16px; }
      .glb-prev:hover, .glb-next:hover { background: rgba(255,255,255,0.25); }
      .glb-prev:disabled, .glb-next:disabled { opacity: 0.25; cursor: default; }
      .our-gallery__item { cursor: zoom-in; }
    `;

    document.head.appendChild(style);
    document.body.appendChild(lb);
    return lb;
  }

  function initGalleryLightbox() {
    const lb     = buildLightbox();
    const img    = lb.querySelector('.glb-img');
    const caption = lb.querySelector('.glb-caption');
    const btnClose = lb.querySelector('.glb-close');
    const btnPrev  = lb.querySelector('.glb-prev');
    const btnNext  = lb.querySelector('.glb-next');
    const backdrop = lb.querySelector('.glb-backdrop');

    let items  = [];
    let current = 0;

    function collectItems() {
      items = Array.from(document.querySelectorAll('.our-gallery__item .our-gallery__img'));
    }

    function open(index) {
      collectItems();
      current = index;
      show();
      lb.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function show() {
      const el = items[current];
      if (!el) return;

      // Load full-size image (swap width param for larger size)
      const fullSrc = el.src.replace(/width=\d+/, 'width=1600');

      img.classList.add('loading');
      img.src = '';
      img.src = fullSrc;
      img.alt = el.alt || '';
      img.onload = () => img.classList.remove('loading');

      // Caption from sibling element
      const captionEl = el.closest('.our-gallery__item')?.querySelector('.our-gallery__caption');
      caption.textContent = captionEl ? captionEl.textContent : (el.alt || '');

      btnPrev.disabled = current === 0;
      btnNext.disabled = current === items.length - 1;
    }

    function close() {
      lb.classList.remove('active');
      document.body.style.overflow = '';
      img.src = '';
    }

    function prev() { if (current > 0) { current--; show(); } }
    function next() { if (current < items.length - 1) { current++; show(); } }

    // Events
    btnClose.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    btnPrev.addEventListener('click', prev);
    btnNext.addEventListener('click', next);

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('active')) return;
      if (e.key === 'Escape')      close();
      if (e.key === 'ArrowLeft')   prev();
      if (e.key === 'ArrowRight')  next();
    });

    // Delegate click on gallery images
    document.addEventListener('click', function (e) {
      const galleryImg = e.target.closest('.our-gallery__item .our-gallery__img');
      if (!galleryImg) return;

      // If the item has a link, block lightbox so the link still works
      const link = galleryImg.closest('.our-gallery__item')?.querySelector('.our-gallery__link');
      if (link) return; // remove this check if you want lightbox to override links

      collectItems();
      const index = items.indexOf(galleryImg);
      if (index !== -1) { e.preventDefault(); open(index); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryLightbox);
  } else {
    initGalleryLightbox();
  }
})();